<div id="mySidepanel" class="sidepanel" [ngClass]="{'isSideBarOpen':isSideBarOpen === true ? true : false}">
  <a href="javascript:void(0)" class="closebtn" (click)="isSideBarOpen = false">×</a>
  <div class="row">
    <div class="col-md-8">
      <span>Hello,</span> <br>
      <span class="userName" *ngIf="userName">{{userName}}</span> <span class="userName" *ngIf="!userName">User</span>
      <br>
      <!-- <p class="user-bio">Copy your bio link and paste it in your profile to let people find you.</p> -->
    </div>
    <div class="col-md-4">
      <img src="../assets/user.svg" alt="">
    </div>
  </div>
  <div>
    <button style="font-size: 14px; padding: 10px 15px;" class="btn btn-outline-primary d-flex align-items-center"
      (click)="showConfirmDialog()">
      <i class="fa fa-lock" style="margin-right: 8px;"></i>
      Change Password
    </button>
  </div>
</div>

<div>
  <p-dialog header="Reset Password" [(visible)]="showConfirmationDialog" [closable]="false" [modal]="true"
    [style]="{width: '50vw'}">
    <form [formGroup]="passwordForm" (ngSubmit)="submitChangePassword()" class="password-form">
      <div class="form-group">
        <label for="currentPassword">Current Password:</label>
        <div class="password-input">
          <input type="{{ hideCurrentPassword ? 'password' : 'text' }}" id="currentPassword"
            formControlName="currentPassword" class="form-control">
          <span class="eye-icon" (click)="togglePasswordVisibility('current')">
            <i [class]="hideCurrentPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
          <div *ngIf="f.newPassword.touched && f.currentPassword.errors?.required" class="text-danger">
            current password is required
          </div>
          <div *ngIf="passwordForm.get('currentPassword')?.errors?.minlength" class="text-danger">
            Password must be at least 8 characters long.
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="newPassword">New Password:</label>
        <div class="password-input">
          <input type="{{ hideNewPassword ? 'password' : 'text' }}" id="newPassword" formControlName="newPassword"
            class="form-control">
          <span class="eye-icon" (click)="togglePasswordVisibility('new')">
            <i [class]="hideNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
          <div *ngIf="f.newPassword.touched && f.newPassword.errors?.required" class="text-danger">
            New password is required
          </div>
          <div *ngIf="!f.newPassword.errors?.required && f.newPassword.errors?.uppercaseRequired" class="text-danger">
            Password must contain at least one uppercase letter.
          </div>
          <div *ngIf="!f.newPassword.errors?.required && f.newPassword.errors?.lowercaseRequired" class="text-danger">
            Password must contain at least one lowercase letter.
          </div>
          <div *ngIf="!f.newPassword.errors?.required && f.newPassword.errors?.numberRequired" class="text-danger">
            Password must contain at least one digit.
          </div>
          <div *ngIf="!f.newPassword.errors?.required && f.newPassword.errors?.specialCharRequired" class="text-danger">
            Password must contain at least one special character.
          </div>
          <div *ngIf="!f.newPassword.errors?.required && f.newPassword.errors?.minLengthRequired" class="text-danger">
            Password must be at least 8 characters long.
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="confirmPassword">Confirm Password:</label>
        <div class="password-input">
          <input type="{{ hideConfirmPassword ? 'password' : 'text' }}" id="confirmPassword"
            formControlName="confirmPassword" class="form-control">
          <span class="eye-icon" (click)="togglePasswordVisibility('confirm')">
            <i [class]="hideConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
          <div *ngIf="f.newPassword.touched && f.confirmPassword.errors?.required" class="text-danger">
            confirm password is required
          </div>
          <div *ngIf="f.confirmPassword.touched && f.confirmPassword.errors?.passwordMismatch" class="text-danger">
            Passwords do not match.
          </div>
        </div>
      </div>
    </form>

    <p-footer>
      <button type="button" pButton icon="pi pi-check" label="Submit" (click)="onConfirm()"
        [disabled]="passwordForm.invalid"></button>
      <button type="button" pButton icon="pi pi-times" label="Cancel" (click)="onCancel()"></button>
    </p-footer>
  </p-dialog>
</div>

<div class="sidenav">
  <div class="open-panal-btn">
    <i class="fa fa-bars" aria-hidden="true" (click)="isSideBarOpen = true"></i>
  </div>
  <div class="sidebarIcon" *ngFor="let item of sidebarItems; let ind = index"
    (click)="selecteByRoute(item, ind);scrollToTop()" [class.active]="activeIndex === ind">
    <div *ngIf="item.visibility && item.visibility === true">
      <i title={{item.title}} class={{item.icons}}></i>
    </div>

  </div>
</div>